import { areasTree } from "./areas-tree-screen.js";
import { areasFavorites } from "./areas-favorites-screen.js";

export default {
	areasTree,
	areasFavorites
}